define(function(require) {
	const data_item_tpl = require('../templates/t_itv_data_item.hbs');
	const utils = require('civicsUtils/general_utilities');
	return Marionette.ItemView.extend({
		events:{
			'click @ui.editButton':'editClicked',
			'click @ui.saveButton':'saveClicked',
			'click @ui.cancelButton':'cancelClicked'
		},
		template:data_item_tpl,
		tagName:'div',
		ui:{
			'editButton':'.edit-btn',
			'saveButton':'.save-btn',
			'cancelButton':'.cancel-btn'
		},
		attributes:function(){
			//set the appropriate css class for the width of the column. We allow layouts up to 4 columns wide.
			var className = '';
			if(this.options && this.options.model && this.options.model.attributes){
				if(this.options.model.attributes.columnWidth>=1 && this.options.model.attributes.columnWidth<=4){
					className = ' column-span-' + this.options.model.attributes.columnWidth;
					if (this.options.model.attributes.columnClass) {
						className += ' ' + this.options.model.attributes.columnClass;
					}
				}
			}
			return {
				class:'data-column'+className
			};
		},
		initialize:function(options){
			var editOptions = this.model.get('editOptions');
			//make sure it exists, and it's a backbone model
			if(editOptions && editOptions.attributes){
				editOptions = editOptions.toJSON();
				 if(editOptions.editable === true){
					this.editable = true;
					if(editOptions.maxLength && editOptions.maxLength>0){
						this.maxLength = editOptions.maxLength;
					}
					//default to false
					editOptions.editOnValue = (editOptions.editOnValue === true);
					editOptions.editOnDescription = !editOptions.editOnValue;
				} else {
					editOptions.editable = false;
				}
				this.model.set({
					editOptions:editOptions,
				},{silent:true});
				if(this.model.get('originalValue') == null){
					//set original value in case we try to save but fail.
					//then we can set the value back to the original.
					this.model.set({originalValue:this.model.get('value')},{silent:true});
				}
			}
			if (options && options.isModal) {
				this.isModal = options.isModal;
			}
			this.model.on('change',this.render,this);

		},
		onBeforeRender:function(){
			//if the value is empty, set the dataType to html and the value to &nbsp; to keep the div from collapsing.
			var val = this.model.get('value');

			var dType = this.model.get('dataType') ? this.model.get('dataType') : 'string';
			//store the original values, in case we need to alter it to &nbsp; we don't want to show that to the user / allow html to be displayed after edit
			this.model.set({
				//don't show the non breaking space when editing.
				editVal: val == '&nbsp;' ? '' : val,
				originalDataType:dType
			}, {silent:true});
			if(val === undefined ||
				val === null ||
				(typeof val == 'string' && val.trim() === "" )||
				(dType.indexOf('date')>=0 && !utils.dateExists(val))){
				this.model.set({
					dataType:'html',
					value:'&nbsp;'
				},
				{	//silent to prevent any re-render anywhere.
					silent:true
				});
			} else {
				//if value now has data, set datatype back to the original type. This should always be string.
				if(this.model.get('originalDataType')){
					this.model.set({dataType:this.model.get('originalDataType')});
				}
			}
		},
		onRender:function(){
			this.bindClickables();
			this.$el.find('input,textarea').maxlength();
		},
		templateHelpers:function(){
			return {
				is:this.isDataType(),
				editting:this.model.get('editting') === true,
				textArea:this.maxLength && this.maxLength>100,
				maxlength: this.maxLength,
				elementId: this.model.cid,
				isModal: this.isModal,
				editLabel: i18n.t('CIVICS.COMMON.EDIT'),
				cancelLabel: i18n.t('CIVICS.COMMON.CANCEL'),
				saveLabel: i18n.t('CIVICS.COMMON.SAVE')
			};
		},
		bindClickables:function(){
			//we need to catch clickable objects in HTML formatted data, then trigger the associated method on the parent.
			//since the data is rendered after this.ui is set up, we have to bind it manually once it's rendered
			if(this.model.get('dataType') == 'html'){
				var clickable = this.$el.find('.clickable');
				var self = this;
				clickable.on('click',function(e){
					if(e){
						e.preventDefault();
						e.stopPropagation();
					}
					var funcName = e.target.dataset.functionname;
					if(funcName && funcName.length>1){
						//pass the function name up to our parent.
						self.trigger('clickableClicked',funcName);
					}
				});
			}
		},

		//create an object for use in the handlebars template that has a true for the format type.
		//prevents having to do 8 or more global:compareEqual functions
		isDataType:function(){
			var ret = {};
			var dataType = this.model.get('dataType');
			if(dataType){
				switch (dataType.toLowerCase()){
					case 'html':
						ret.html = true;
						break;
						//when you want to strip HTML, but keep line breaks and such
					case 'preservewhitespace':
						ret.preservewhitespace = true;
					case 'number':
						ret.number = true;
						break;
					case 'decimal':
						ret.decimal = true;
						break;
					case 'currency':
						ret.currency = true;
						break;
					case 'date':
						ret.date = true;
						break;
					case 'datetime':
						ret.datetime = true;
						break;
					case 'time':
						ret.time = true;
						break;
					case 'bool':
						ret.bool = true;
						break;
					case 'link':
						ret.link = true;
						break;
					default:
						ret.string = true;
						break;
				}
			} else {
				ret.string = true;
			}
			return ret;
		},
		cancelClicked:function(e){
			if(e){
				e.preventDefault();
				e.stopPropagation();
			}
			//console.log('cancelling');
			//triggers a method on the parent CPV
			this.trigger('editItemDone');
			this.model.set({
				editting:false,
				value:this.model.get('originalValue')
				});
		},
		editClicked:function(e){
			if(e){
				e.preventDefault();
				e.stopPropagation();
			}
			//console.log('editting');
			//use silent so we don't render multiple times. The editItemClicked method will cause this view to re-render.
			this.model.set({editting:true},{silent:true});
			this.trigger('editItemClicked');

		},
		saveClicked:function(e){
			if(e){
				e.preventDefault();
				e.stopPropagation();
			}
			//console.log('saving');
			var newVal = this.$el.find('input,textarea').val();
			//update the value of the model to the value of the input field
			this.model.set('value',newVal,{silent:true});

			this.editSavedPromise = new $.Deferred();

			//if we get an error from the server we'll want to know.
			var response;

			//triggers a method on the parent CPV
			this.trigger('saveEditsToServer',this.model,this.editSavedPromise, response);

			var self = this;
			$.when(this.editSavedPromise)
			.done(function(){
					//triggers a method on the parent CPV
					self.trigger('editItemDone');
					self.model.set({
						editting:false,
						originalValue:newVal
					});
				})
			.fail(function(){
				//if save fails, the error from the server should appear in a banner and the edit box will not close.
				//the user can read the message, and determine the correct steps to take at that point.
				//other functionality for a fail state can be added here.
				//console.log('Save Failed');

				//reset the value so if they hit cancel the right value shows up.
				this.model.set({value:this.model.get('originalValue')},{silent:true});

			}.bind(this));
			//this.editSavedPromise.resolve();
		},
	});
});
